<template>
  <div>
    <UploadFile
      attachmentRoute="attachment_special"
      attachment_type_name="attachment_type_person_special"
      :allowCollapse="true"
      :isCollapseFiles="true"
      :propAttachmentType="true"
      :file_types="fileTypes"
      :parent_attachment_type_options="attachmentTypeOptions"
      :keyServies="keyServies"
      :keyValue="keyValue"
      :parentPermissions="parentPermissions"
    />
  </div>
</template>
<script>
import UploadFile from "@/components/base/uploadFile";
import { renderEumOptions } from "@/shared/utils";
import { includes } from "ramda";

export default {
  name: "attachment-person-special",
  components: {
    UploadFile,
  },
  props: {
    keyServies: {
      type: [String, Number],
      default: null,
    },
    keyValue: {
      type: [String, Number],
      default: null,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fileTypes: ["image", "office", "media", "other"],
    };
  },
  computed: {
    attachmentTypeOptions() {
      return renderEumOptions("attachment_type_person_special");
    },
  },
  methods: {
    renderEumOptions,
    includes,
  },
};
</script>